#import "../fragments/entity-summary-fragment.graphql"

mutation DeleteEntitySummary($input: EntitySummaryDeleteInput!) {
    entitySummaryDelete(input: $input) {
        entitySummary {
            ...EntitySummaryFragment
        }
    }
}
